import { documentResourceToFormValues } from './document-resource-to-form-values';

import type { BusinessDocumentsFormValues } from '../../model/schemas';
import type { DocumentResource } from '../../model/types';

export function recoverBusinessDocuments(
  businessDocuments: DocumentResource[] | undefined
): BusinessDocumentsFormValues | undefined {
  if (!businessDocuments?.length) return undefined;

  const {
    BUSINESS_PERMIT,
    BIR_CERTIFICATE_OR_FORM2303,
    DTI_CERTIFICATE,
    OTHER,
  } = businessDocuments.reduce<{
    BUSINESS_PERMIT: DocumentResource | undefined;
    BIR_CERTIFICATE_OR_FORM2303: DocumentResource | undefined;
    DTI_CERTIFICATE: DocumentResource | undefined;
    OTHER: DocumentResource[];
  }>(
    (acc, document) => {
      if (document.type === 'BUSINESS_PERMIT') {
        acc.BUSINESS_PERMIT = document;
        return acc;
      }
      if (document.type === 'BIR_CERTIFICATE_OR_FORM2303') {
        acc.BIR_CERTIFICATE_OR_FORM2303 = document;
        return acc;
      }
      if (document.type === 'DTI_CERTIFICATE') {
        acc.DTI_CERTIFICATE = document;
        return acc;
      }
      if (document.type === 'OTHER') {
        acc.OTHER.push(document);
        return acc;
      }
      return acc;
    },
    {
      BUSINESS_PERMIT: undefined,
      BIR_CERTIFICATE_OR_FORM2303: undefined,
      DTI_CERTIFICATE: undefined,
      OTHER: [],
    }
  );

  return {
    BUSINESS_PERMIT: BUSINESS_PERMIT
      ? documentResourceToFormValues(BUSINESS_PERMIT)
      : null,
    BIR_CERTIFICATE_OR_FORM2303: BIR_CERTIFICATE_OR_FORM2303
      ? documentResourceToFormValues(BIR_CERTIFICATE_OR_FORM2303)
      : null,
    DTI_CERTIFICATE: DTI_CERTIFICATE
      ? documentResourceToFormValues(DTI_CERTIFICATE)
      : null,
    OTHER: OTHER.map(documentResourceToFormValues),
  } as BusinessDocumentsFormValues;
}
